import React from 'react';
import Head from "next/head";
import {isEmpty} from "../helpers/helpers";

function Metas({
                   pageTitle,
                   robots,
                   descriptionMeta,
                   ogTitle,
                   ogDescription,
                   pageImages,
                   originalCanonicalLink,
                   canonicalLink,
                   pageArticle
               }) {
    return (
        <Head>
            <meta charSet="utf-8"/>
            <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"/>

            <meta name="yn-tag" id="7f62f6df-6999-4715-894f-44c7d724f4ed"/>

            {
                (process.env.NEXT_PUBLIC_APP_ENV === 'production') ?
                    <meta name="robots"
                          content={!isEmpty(robots) ? robots : ((process.env.NEXT_PUBLIC_APP_ENV === 'production') ? 'index, follow, all' : 'NOODP, nofollow, noindex')}/>
                    :
                    <meta name="robots" content="NOODP, nofollow, noindex"/>
            }

            <meta name="description" content={descriptionMeta}/>
            <meta property="og:description"
                  content={(ogDescription !== "undefined") ? ogDescription : descriptionMeta}/>
            <meta name="twitter:description"
                  content={(ogDescription !== "undefined") ? ogDescription : descriptionMeta}/>
            <link rel="shortcut icon" type="image/x-icon" href="/_favicon.ico"/>
            <link rel="manifest" href="/_manifest.json"/>

            <meta name="msapplication-starturl" content="/"/>
            <meta name="msapplication-TileColor" content="#FFF"/>
            <meta name="msapplication-TileImage" content="/ms-icon-144x144.png"/>

            <meta name="theme-color" content="#160647"/>
            <meta name="msapplication-navbutton-color" content="#160647"/>
            <meta name="apple-mobile-web-app-status-bar-style" content="#160647"/>
            <meta name="mobile-web-app-capable" content="yes"/>
            <meta name="apple-mobile-web-app-capable" content="yes"/>

            <meta name="apple-mobile-web-app-title" content="۲نبش"/>
            <link rel="apple-touch-icon" sizes="57x57" href="/_img/icons/fav/apple-icon-57x57.png"/>
            <link rel="apple-touch-icon" sizes="60x60" href="/_img/icons/fav/apple-icon-60x60.png"/>
            <link rel="apple-touch-icon" sizes="72x72" href="/_img/icons/fav/apple-icon-72x72.png"/>
            <link rel="apple-touch-icon" sizes="76x76" href="/_img/icons/fav/apple-icon-76x76.png"/>
            <link rel="apple-touch-icon" sizes="114x114" href="/_img/icons/fav/apple-icon-114x114.png"/>
            <link rel="apple-touch-icon" sizes="120x120" href="/_img/icons/fav/apple-icon-120x120.png"/>
            <link rel="apple-touch-icon" sizes="144x144" href="/_img/icons/fav/apple-icon-144x144.png"/>
            <link rel="apple-touch-icon" sizes="152x152" href="/_img/icons/fav/apple-icon-152x152.png"/>
            <link rel="apple-touch-icon" sizes="180x180" href="/_img/icons/fav/apple-icon-180x180.png"/>
            <link rel="apple-touch-icon" href="/_img/icons/fav/apple-icon.png"/>
            <link rel="apple-touch-startup-image" href="/_img/icons/fav/apple-icon.png"/>
            <meta name="apple-mobile-web-app-capable" content="yes"/>
            <meta name="apple-mobile-web-app-status-bar-style" content="default"/>

            <link rel="icon" sizes="192x192" href="/_img/icons/fav/android-icon-192x192.png"/>
            <link rel="icon" sizes="32x32" href="/_img/icons/fav/favicon-32x32.png"/>
            <link rel="icon" sizes="96x96" href="/_img/icons/fav/favicon-96x96.png"/>
            <link rel="icon" sizes="16x16" href="/_img/icons/fav/favicon-16x16.png"/>
            <link rel="icon" href="/_img/green-app-icon.png"/>
            <meta name="application-name" content="۲نبش"/>
            <meta name="mobile-web-app-capable" content="yes"/>

            <meta name="layoutmode" content="fitscreen/standard"/>
            <link rel="home" href="/"/>

            <meta property="og:title"
                  content={(ogTitle !== "undefined") ? ogTitle : ((pageTitle !== "undefined") ? pageTitle + " | ۲نبش" : "۲نبش")}/>
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:title"
                  content={(ogTitle !== "undefined") ? ogTitle : ((pageTitle !== "undefined") ? pageTitle + " | ۲نبش" : "۲نبش")}/>

            <meta property="og:site_name" content="۲نبش"/>
            {(undefined !== pageImages && Array.isArray(pageImages) && pageImages.length) ?
                pageImages.map((imageUrl) =>
                    <React.Fragment>
                        <meta property="og:image" content={imageUrl}/>
                        <meta name="twitter:image" content={imageUrl}/>
                    </React.Fragment>
                ) :
                <React.Fragment>
                    <meta property="og:image" content="/_img/green-app-icon.png"/>
                    <meta name="twitter:image" content="/_img/green-app-icon.png"/>
                </React.Fragment>
            }

            <meta property='og:locale' content='fa_IR'/>

            {
                (!isEmpty(canonicalLink)) ?
                    <React.Fragment>
                        <meta property='og:url'
                              content={'https://www.2nabsh.com' + ((!isEmpty(originalCanonicalLink)) ? originalCanonicalLink : canonicalLink)}/>
                        <link rel='canonical' href={'https://www.2nabsh.com' + canonicalLink}/>
                        <meta name='twitter:url'
                              content={'https://www.2nabsh.com' + ((!isEmpty(originalCanonicalLink)) ? originalCanonicalLink : canonicalLink)}/>
                    </React.Fragment>
                    : ''
            }

            {
                ("undefined" !== pageArticle && Array.isArray(pageArticle)) ??
                <React.Fragment>
                    <meta property='og:type' content='article'/>
                    <meta property='og:published_time' content={pageArticle['published_time']}/>
                </React.Fragment>
            }
            {
                ("undefined" !== pageArticle['author']) ??
                <meta property='og:author' content={pageArticle['author']}/>
            }

            <meta property='og:section' content={pageArticle['section']}/>

            {(undefined !== pageArticle['tags']) ?
                pageArticle['tags'].map((tag) =>
                    <meta property='og:tag' content={tag}/>
                )
                :
                <meta property='og:type' content='website'/>
            }
            <title>{!isEmpty(pageTitle) ? pageTitle + ' | ۲نبش' : '۲نبش'}</title>

            {/* Yektanet */}
            <meta name="yn-tag" id="7aec5d85-c144-4d35-af53-aaf2c408bcda"/>

        </Head>
    )
}

export default React.memo(Metas);